// extracted by mini-css-extract-plugin
module.exports = {"container":"article_item-module_container_89ecd","link":"article_item-module_link_c146b"};